// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","button":"styles_button__1e8lY","digitalBillButton":"styles_digitalBillButton__3mL5H","flex":"styles_flex__15ruQ"};